// Estados de grabación: única fuente de verdad para etiquetas, colores y
// opciones de filtro. Antes esta información estaba duplicada en
// customDataTable, citationDetails, FloatingPanel y los 3 filtros.

export const RECORDING_STATUS_MAP = {
  empty: { title: "Sin audio", color: "#fd846d" },
  "edited pending encoding": {
    title: "Editado pendiente codificar",
    color: "#f6ae2d",
  },
  "pending encoding": { title: "Pendiente codificar", color: "#f6ae2d" },
  encoded: { title: "Codificado", color: "#689840" },
  "encoded another session": {
    title: "Codificado en otra sesion",
    color: "#689840",
  },
};

export const AUDIO_MASTER_STATUS = { title: "Audio master", color: "#689840" };

// Devuelve { title, color } para un estado.
// Si audioMaster es true, fuerza el estado "Audio master".
export function getStatusInfo(status, audioMaster = false) {
  if (audioMaster) return AUDIO_MASTER_STATUS;
  return RECORDING_STATUS_MAP[status] || { title: "", color: "" };
}

// Opciones para los selects de filtro (sin "Audio master").
export const RECORDING_STATUS_OPTIONS = [
  { name: "Sin audio", type: "empty" },
  { name: "Editado pendiente codificar", type: "edited pending encoding" },
  { name: "Pendiente codificar", type: "pending encoding" },
  { name: "Codificado", type: "encoded" },
  { name: "Codificado en otra sesion", type: "encoded another session" },
];

// Igual que el anterior pero incluyendo "Audio Master"
// (usado en el detalle de convocatoria).
export const RECORDING_STATUS_OPTIONS_WITH_MASTER = [
  { name: "Sin audio", type: "empty" },
  { name: "Editado pendiente codificar", type: "edited pending encoding" },
  { name: "Pendiente codificar", type: "pending encoding" },
  { name: "Audio Master", type: "audio master" },
  { name: "Codificado", type: "encoded" },
  { name: "Codificado en otra sesion", type: "encoded another session" },
];
